// src/components/Captcha.jsx
import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const Captcha = ({ onVerify }) => {
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  const handleChange = (value) => {
    onVerify(value);
  };

  if (!siteKey) {
    console.warn('REACT_APP_RECAPTCHA_SITE_KEY is missing');
    return (
      <p className="has-text-warning has-text-centered">
        reCAPTCHA is currently unavailable.
      </p>
    );
  }

  return (
    <ReCAPTCHA
      sitekey={siteKey}
      onChange={handleChange}
      
    />
    
  );
  console.log("🔑 Loaded sitekey:", siteKey);
};

export default Captcha;
